import React from 'react';
import { Link } from 'react-router-dom';
import PartnerTip from './PartnerTip';

function ArticleRenderer({ sections }) {
  if (!sections?.length) return null;

  return (
    <div className="prose prose-gray max-w-none space-y-4 text-gray-700">
      {sections.map((block, index) => {
        const key = `${block.type}-${index}`;

        switch (block.type) {
          case 'heading': {
            const Tag = block.level === 3 ? 'h3' : 'h2';
            return (
              <Tag
                key={key}
                className={`font-bold text-gray-900 ${
                  block.level === 3 ? 'text-lg mt-6' : 'text-xl mt-8'
                }`}
              >
                {block.text}
              </Tag>
            );
          }
          case 'paragraph':
            return (
              <p key={key} className="leading-relaxed">
                {block.text}
              </p>
            );
          case 'list':
            return (
              <ul key={key} className="list-disc list-inside space-y-2 pl-1">
                {block.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            );
          case 'tip':
            return (
              <div
                key={key}
                className="p-4 bg-green-50 border border-green-100 rounded-lg text-green-900 text-sm"
              >
                <span className="font-semibold">Tip: </span>
                {block.text}
              </div>
            );
          case 'warning':
            return (
              <div
                key={key}
                className="p-4 bg-amber-50 border border-amber-200 rounded-lg text-amber-900 text-sm"
              >
                <span className="font-semibold">Important: </span>
                {block.text}
              </div>
            );
          case 'link':
            return (
              <p key={key}>
                <Link to={block.to} className="text-blue-600 hover:underline font-medium">
                  {block.label} →
                </Link>
              </p>
            );
          case 'lookupCta':
            return (
              <div
                key={key}
                className="p-4 bg-gray-50 border border-gray-200 rounded-lg"
              >
                <p className="font-medium text-gray-900">Looking up a number?</p>
                <p className="text-sm text-gray-600 mt-1">
                  Search on WhoDatNumber and read community reports before you call back.
                </p>
                <Link
                  to="/"
                  className="inline-block mt-3 text-sm font-medium text-blue-600 hover:underline"
                >
                  Search a phone number →
                </Link>
              </div>
            );
          case 'partnerTip':
            return (
              <PartnerTip
                key={key}
                partnerId={block.partnerId || 'onePassword'}
                variant={block.variant || 'primary'}
              />
            );
          default:
            return null;
        }
      })}
    </div>
  );
}

export default ArticleRenderer;

